// import PhotoSwipe from "photoswipe";
// import PhotoSwipeLightbox from "photoswipe/lightbox";

/* global PhotoSwipe, PhotoSwipeLightbox: false */

export default class PhotoGallery {
	constructor(element) {
		if (!element) return;

		this.element = element;

		this.init();
	}

	init() {
		const lightbox = new PhotoSwipeLightbox({
			gallery: this.element,
			children: "a",
			showHideAnimationType: "fade",
			pswpModule: PhotoSwipe,
		});

		lightbox.addFilter("itemData", (itemData, index) => {
			const videoSrc = itemData.element.dataset.pswpVideoSrc;
			if (videoSrc) {
				itemData.videoSrc = videoSrc;
			}
			return itemData;
		});

		// use <video> instead of <img>
		lightbox.on("contentLoad", (e) => {
			const { content, isLazy } = e;
			if (content.data.videoSrc) {
				// prevent to stop the default behavior
				e.preventDefault();

				//   content.pictureElement = document.createElement('picture');
				// content.videoElement = document.createElement("video");
				content.videoElement = document.createElement("div");
				content.videoElement.classList.add("video-wrapper");

				content.videoElement.addEventListener('click', ()=>{
					document.querySelector('.pswp__button--close').click();
				})

				// content.videoElement.preload = "none";
				content.element = document.createElement("video");
				content.element.preload = "none";
				content.element.controls = "true";
				// content.element.autoplay = "true";

				const sourceVideo = document.createElement("source");
				sourceVideo.src = content.data.videoSrc;
				sourceVideo.type = "video/mp4";

				//   const sourceJpg = document.createElement('source');
				//   sourceJpg.srcset = content.data.src;
				//   sourceJpg.type = 'image/jpeg';

				// content.element = document.createElement("video");
				// content.element.src = content.data.src;
				// content.element.setAttribute("alt", "");
				// content.element.className = "pswp__img";

				// content.videoElement.appendChild(sourceVideo);
				content.element.appendChild(sourceVideo);

				content.videoElement.appendChild(content.element);
				//   content.pictureElement.appendChild(sourceJpg);
				//   content.videoElement.appendChild(content.element);

				content.state = "loading";

				if (content.element.complete) {
					content.onLoaded();
				} else {
					content.element.onload = () => {
						content.onLoaded();
					};

					content.element.onerror = () => {
						content.onError();
					};
				}
			}
		});

		// by default PhotoSwipe appends <img>,
		// but we want to append <video>
		lightbox.on("contentAppend", (e) => {
			// console.log("contentAppend");
			const { content } = e;
			if (content.videoElement && !content.videoElement.parentNode) {
				e.preventDefault();
				content.slide.container.appendChild(content.videoElement);
			}
		});

		// for next/prev navigation with <picture>
		// by default PhotoSwipe removes <img>,
		// but we want to remove <picture>
		lightbox.on("contentRemove", (e) => {
			// console.log("contentRemove");
			const { content } = e;
			if (content.videoElement && content.videoElement.parentNode) {
				e.preventDefault();
				// console.log("video removed");
				content.videoElement.remove();
			}
		});

		lightbox.on("contentActivate", ({ content }) => {
			if (content.videoElement) {
				// e.preventDefault();
				// console.log("video slide activated");
				content.element.play();
				// content.videoElement.remove();
			}
			// content becomes active (the current slide)
			// can be default prevented
			// console.log("contentActivate", content);
		});

		lightbox.on("contentDeactivate", ({ content }) => {
			// content becomes inactive
			// can be default prevented
			// console.log('contentDeactivate', content);
			if (content.videoElement && content.videoElement.parentNode) {
				// e.preventDefault();
				// console.log("video slide activated");
				content.element.pause();
				// content.videoElement.remove();
			}
		});

		// const videoPlugin = new PhotoSwipeVideoPlugin(lightbox, {
		// 	// options
		// });

		lightbox.init();
	}
}
